<template>
    <div>
        <div class="group" :key="group.key" v-for="group in chartsOptions">
            <div class="group-label">{{ group.label }}</div>
            <b-form-checkbox
                :key="option.infoType"
                v-for="option in group.options"
                :checked="chartIsIncluded(option.infoType)"
                @change="onAddOrRemoveChart($event, option)"
            >
                <span
                    :class="{
                        'font-bold': chartIsIncluded(option.infoType),
                    }"
                >
                    {{ option.text }}</span
                >
            </b-form-checkbox>
        </div>
    </div>
</template>
<script>
import { CHART_INFO_TYPES, CHART_FORMATS } from '@/views/reports/constants'
export default {
    props: {
        selectedOptions: Array,
    },
    methods: {
        onAddOrRemoveChart(adding, option) {
            if (adding) {
                this.addChart(option)
            } else {
                this.removeChart(option)
            }
        },
        addChart(option) {
            const selected = [{ ...option }, ...this.selectedOptions]
            this.emitUpdateEvent(selected)
        },
        removeChart(option) {
            const selected = this.selectedOptions.filter(
                c => c.infoType != option.infoType
            )
            this.emitUpdateEvent(selected)
        },
        emitUpdateEvent(newValue) {
            this.$emit('update:selectedOptions', newValue)
        },
        chartIsIncluded(infoType) {
            const infoTypes = this.selectedOptions.map(c => c.infoType)
            return infoTypes.includes(infoType)
        },
    },
    computed: {
        chartsOptions() {
            return [
                {
                    key: 'networkAndProcess',
                    label: this.$t('reports.dashboards.networkAndProcess'),
                    options: [
                        {
                            text: this.$t('reports.dashboards.evaluations'),
                            format: CHART_FORMATS.BAR,
                            infoType: CHART_INFO_TYPES.EVALUATIONS_STATUS,
                        },
                        {
                            text: this.$t(
                                'reports.dashboards.teamsEvaluations'
                            ),
                            format: CHART_FORMATS.BAR,
                            infoType:
                                CHART_INFO_TYPES.EVALUATIONS_STATUS_BY_TEAM,
                        },
                    ],
                },
                {
                    key: 'scoresAndResults',
                    label: this.$t('reports.dashboards.scoresAndResults'),
                    options: [
                        {
                            text: this.$t(
                                'reports.dashboards.questionnairesAverage'
                            ),
                            format: CHART_FORMATS.TABLE,
                            infoType: CHART_INFO_TYPES.QUESTIONNAIRES_RESULTS,
                        },
                        {
                            text: this.$t(
                                'reports.dashboards.comparisonOfSubjectsByTypeOfNetwork'
                            ),
                            format: CHART_FORMATS.RADAR,
                            infoType:
                                CHART_INFO_TYPES.SUBJECTS_RESULTS_BY_NETWORK,
                        },
                    ],
                },
            ]
        },
    },
}
</script>
<style lang="scss" scoped>
$dark-blue: #022b4f;
$dark-blue-opaque: rgba($dark-blue, 0.3);

.group {
    position: relative;
    margin-bottom: 16px;

    .group-label {
        margin-bottom: 16px;
        padding-bottom: 3px;
        border-bottom: 1px solid #bec0c0;
    }
}

/deep/ .font-bold {
    font-weight: 500;
}

/deep/ .custom-control-input:checked ~ .custom-control-label::before {
    border: none;
    background-color: $dark-blue;
}

/deep/
    .custom-control-input:focus:not(:checked)
    ~ .custom-control-label::before {
    border-color: $dark-blue-opaque;
}

/deep/
    .custom-control-input:not(:disabled):active
    ~ .custom-control-label::before {
    background-color: $dark-blue-opaque;
    border-color: $dark-blue-opaque;
}
</style>
